import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";

@Pipe({
  standalone: true,
  name: 'crowdfunding',
})
export class CrowdfundingProgressFormatPipe implements PipeTransform {
  constructor(
      private currencyPipe: CurrencyPipe
  ) {}
  transform(value: any, target: any, currency: any, format: string): any {
    const percent = Math.ceil((value/target) * 100);
    switch (format){
      case 'onlyPercent':
        return percent + '%';
      case 'onlyCollect':
        return  this.currencyPipe.transform(value, currency);
      case 'collectAndTarget':
        return  value + '/' + target + " " + currency;
      case 'collectTargetAndPercent':
        return  value + '/' + target + " " + currency + "("+percent+"%)";

    }
  }

}
